var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    class: ["mku-slider__button", { "mku-slider__button--active": _vm.isDrop }],
    style: _vm.buttonStyle,
    on: {
      mousedown: _vm.handleDragStart,
      mousemove: _vm.handleDraging,
      mouseup: _vm.handleDragEnd
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }